import { Component, OnInit, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ErrorGuides, Message } from '../../../shared/models/error-guides';
import { Router } from '@angular/router';
import { AdminService } from '../../admin.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../../shared/components/confirm-modal/confirm-modal.component';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { TCCPConstantValues } from '../../../shared/models/tccp-constants';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-add-error-guides',
  templateUrl: './add-error-guides.component.html',
  styleUrls: ['./add-error-guides.component.scss']
})
export class AddErrorGuidesComponent implements OnInit {
  public errorGuideForm: FormGroup;
  public errorGuide: ErrorGuides;
  public title: string = 'Add Message Guide';
  public mode: string = 'add';
  public alerts: any[] = [];
  public issubmit: boolean = false;
  public initialErrorGuide: ErrorGuides = <ErrorGuides>{};
  public appName: string = null;
  public errorGuideOptions = [];

  constructor(
    private fb: FormBuilder, private router: Router,
    private adminService: AdminService, private dialog: MatDialog, private authService: MsalService) { }

  ngOnInit() {
    this.appName = environment.applicationName;
    const portalName = this.appName && this.appName === 'admin' ?
      this.adminService.selectedApplication.substring(0, 1).toUpperCase() +
      this.adminService.selectedApplication.substring(1).toLowerCase() : this.appName.substring(0, 1).toUpperCase() +
      this.appName.substring(1).toLowerCase();
    this.errorGuideOptions = [{ name: portalName + ' App', value: 'Mobile App', checked: true },
    { name: 'Dealer Portal', value: 'Dealer Portal', checked: false }]
    this.errorGuide = <ErrorGuides>{};
    this.errorGuide.message = <Message>{};
    if (window.history.state.errorGuide) {
      this.title = 'Edit Message Guide';
      this.mode = 'edit';
      this.errorGuide = window.history.state.errorGuide;
    }
    this.initialErrorGuide = Object.assign({}, this.errorGuide);
    this.errorGuideForm = this.fb.group({
      code: new FormControl(this.errorGuide.code, [Validators.required]),
      platform: new FormControl(this.errorGuide.platform, [Validators.required]),
      tdPR_SP: new FormControl(this.errorGuide.tdPR_SP),
      feature: new FormControl(this.errorGuide.feature, [Validators.required]),
      message: this.fb.group({
        solution: new FormControl(this.errorGuide.message.solution, [Validators.required]),
        contentTCI: new FormControl(this.errorGuide.message.contentTCI),
        effect: new FormControl(this.errorGuide.message.effect, [Validators.required]),
        contentTMNA: new FormControl(this.errorGuide.message.contentTMNA, [Validators.required]),
        description: new FormControl(this.errorGuide.message.description, [Validators.required]),
        cause: new FormControl(this.errorGuide.message.cause, Validators.required),
        shortDescription: new FormControl(this.errorGuide.message.shortDescription, [Validators.required]),
        diagnostic: new FormControl(this.errorGuide.message.diagnostic)
      })
    });
    if (this.mode != 'add') {
      this.errorGuideForm.controls['code'].disable();
      this.errorGuideForm.controls['platform'].disable();
    }
  }

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    this.alerts = [];
    if ((this.mode === 'add' || this.mode === 'edit')) {
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        width: '350px',
        data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
        id: 'admin-' + this.adminService.selectedApplication,
        position: { top: '100px' }
      });
      return dialogRef.afterClosed();
    } else {
      return true;
    }
  }
  public hasError = (controlName: string, errorName: string, groupName?: string) => {
    if (groupName)
      return this.errorGuideForm.controls[groupName]['controls'][controlName].hasError(errorName);
    return this.errorGuideForm.controls[controlName].hasError(errorName);
  }


  onSave(data) {
    this.issubmit = true;
    this.errorGuideForm.markAllAsTouched();
    if (this.errorGuideForm.valid) {
      this.errorGuide = Object.assign(this.errorGuide, this.errorGuideForm.value);
      this.errorGuide.updatedBy = this.authService.instance.getActiveAccount().username;
      if (this.mode == 'add') {
        this.errorGuide.createdBy = this.authService.instance.getActiveAccount().username;
        this.addErrorGuide(this.errorGuide);
      } else if (this.mode == 'edit') {
        this.errorGuideForm.controls['code'].disable();
        this.editErrorGuide(this.errorGuide);
      }
    }
  }

  addErrorGuide(errorGuide: ErrorGuides) {
    this.adminService.createErrorMessages(this.errorGuide).subscribe(data => {
      if (data) {
        this.mode = 'view';
        this.title = 'View Message Guide';
        this.showAlertMessages('success', 'Message Guide is saved successfully.');
        this.errorGuideForm.disable();
      }
    });
  }

  editErrorGuide(errorGuide: ErrorGuides) {
    this.adminService.updateErrorMessages(this.errorGuide).subscribe(data => {
      if (data) {
        this.mode = 'view';
        this.title = 'View Message Guide';
        this.showAlertMessages('success', 'Message Guide is updated successfully.');
        this.errorGuideForm.disable();
      }
    })
  }

  public showAlertMessages(messageType, message) {
    this.alerts = [];
    if (this.alerts.length === 0) {
      this.alerts.push({
        type: messageType,
        msg: message
      });
    }
    window.scroll(0, 0);
  }

  closeAlerts() {
    this.alerts = [];
  }

  onEdit() {
    this.mode = 'edit';
    this.title = 'Edit Message Guide';
    this.errorGuideForm.enable();
    this.errorGuideForm.controls['code'].disable();
    this.errorGuideForm.controls['platform'].disable();
  }

  onCancel() {
    this.openCancelDialog();
  }

  openCancelDialog(): void {
    const dialogRef = this.dialog.open(ConfirmModalComponent, {
      width: '350px',
      data: TCCPConstantValues.admin.messages.LOST_UNSAVED_MESSAGE,
      id: 'admin-' + this.adminService.selectedApplication
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        this.issubmit = false;
        this.errorGuideForm.markAsUntouched();
        if (this.mode == 'add') {
          this.errorGuideForm.reset();
        } else {
          this.mode = 'view';
          this.title = 'View Message Guide';
          this.errorGuideForm.disable();
          this.errorGuideForm.patchValue(this.initialErrorGuide);
        }
      }
    });
  }

}
